<template>
  <table class="deal-table">
    <thead>
      <tr>
        <th class="text-align-left">
          {{ __('Estágio') }}
        </th>
        <th>{{ __('Negócios') }}</th>
        <th>{{ __('Conversão para o estágio seguinte') }}</th>
        <th>{{ __('Conversão do primeiro estágio') }}</th>
        <th>{{ __('Perdidos neste estágio') }}</th>
        <th>{{ __('Conversão para Ganho') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="stage in list">
        <td class="text-align-left">
          {{ name(stage.id) }}
        </td>
        <td>{{ stage.count.progressed + stage.count.lost || 0 | number(0) }}</td>
        <td>{{ stage.count.progressed / (stage.count.progressed + stage.count.lost) || 0 | percent(0) }}</td>
        <td>{{ (stage.count.progressed + stage.count.lost) / init || 0 | percent(0) }}</td>
        <td>{{ stage.count.lost / (stage.count.progressed + stage.count.lost) || 0 | percent(0) }}</td>
        <td>{{ won / (stage.count.progressed + stage.count.lost) || 0 | percent(0) }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ['list', 'stages'],

  computed: {
    init () {
      return this.list.length ? this.list[0].count.progressed + this.list[0].count.lost : 0;
    },

    won () {
      const len = this.list.length;
      return len ? this.list[len - 1].count.progressed : 0;
    },
  },

  methods: {
    name (id) {
      return this.stages[id].name;
    },
  },
};
</script>
